module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-31.248af06d.png";